import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import { useSwipeable } from 'react-swipeable';
/**
 * Custom hook for all logic associated with the Carousel Component
 * @function useCarousel
 * @param {Object[]} elements - An array of items or cards to be displayed in the carousel
 * @returns {Object} - Returns an object of carousel state values and functions (handlers,getOrder,previousSlide,nextSlide,jumpToSlide)
 */

export function useCarousel(_ref) {
  var elements = _ref.elements;
  var numItems = elements.length || 1;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      shouldSlide = _useState4[0],
      setShouldSlide = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      direction = _useState6[0],
      setDirection = _useState6[1];

  useEffect(function () {
    setShouldSlide(false);
  }, [shouldSlide]);
  useEffect(function () {
    setDirection();
  }, [direction]);
  var handlers = useSwipeable({
    onSwipedLeft: function onSwipedLeft() {
      return nextSlide();
    },
    onSwipedRight: function onSwipedRight() {
      return previousSlide();
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  var getOrder = function getOrder(itemIndex) {
    if (itemIndex - position < 0) {
      return numItems - Math.abs(itemIndex - position);
    }

    return itemIndex - position;
  };

  var previousSlide = function previousSlide() {
    setShouldSlide(true);
    setDirection('previous');
    setPosition(position === 0 ? numItems - 1 : position - 1);
  };

  var nextSlide = function nextSlide() {
    setShouldSlide(true);
    setDirection('next');
    setPosition(position === numItems - 1 ? 0 : position + 1);
  };

  var jumpToSlide = function jumpToSlide(newSlide) {
    position !== newSlide && setShouldSlide(true);
    setPosition(position === newSlide ? position : newSlide);
    setDirection(position < newSlide ? 'next' : 'previous');
  }; // Carousel state values


  var carouselState = {
    position: position,
    shouldSlide: shouldSlide,
    direction: direction
  };
  return {
    carouselState: carouselState,
    handlers: handlers,
    getOrder: getOrder,
    previousSlide: previousSlide,
    nextSlide: nextSlide,
    jumpToSlide: jumpToSlide
  };
}